import { MODAL_NOT_CLOSED, SET_AUTH_LABEL, TOGGLE_SIDEBAR } from './auxiliaryActionTypes';

const initialState = {
  authLabel: '/login',
  modal: true,
  collapseBar: false
};

export const auxiliaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH_LABEL:
      return {
        ...state,
        authLabel: action.payload
      };

    case MODAL_NOT_CLOSED:
      return {
        ...state,
        modal: false
      };
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        collapseBar: action.payload
      };

    default: {
      return state;
    }
  }
};
